import React from 'react'
import { Link } from 'react-router-dom'
import SignedInLinks from './SignedInLinks'
import SignedOutLinks from './SignedOutLinks'
import { connect } from 'react-redux'
import { styles } from '../layout/styles'

const Navbar = (props) => {
    const { auth, profile } = props;
    if (!auth.uid) {
        return (
            <div></div>
        )
    } else {
        const links = auth.uid ? <SignedInLinks profile={profile}/> : <SignedOutLinks/>;
        return (
            <nav style={styles.NavDiv}>
                <div style={styles.NavContainer}>
                    <div style={styles.NavInsideDiv}>
                        <h2 style={styles.NavHeader}>Welcome {profile.firstname} {profile.lastname}</h2>
                    </div>
                    <div style={styles.NavInsideDiv}>
                        <h2 style={styles.ProductNameHeader}>ChildrenDoc</h2>
                    </div>
                    <div style={styles.NavInsideDiv}>
                        { links }
                    </div>
                </div>
            </nav>
        )
    }
}

const mapStateToProps = (state) => {
    //console.log(state);
    return {
        auth: state.firebase.auth,
        profile: state.firebase.profile
    }
}

export default connect(mapStateToProps)(Navbar)
